import { useWazuhAgents } from '../hooks/useAgents';
import AgentList, { Pill, fmtWhen } from '../components/AgentList';

// What Wazuh actually holds, right now. The manager itself (agent 000) is
// filtered out server-side — it is not an enrolled endpoint and counting it
// would overstate coverage by one.

function WazuhAgents() {
  const { data, isLoading, isFetching, error, refetch } = useWazuhAgents();

  const columns = [
    { key: 'id', label: 'ID', render: (a) => <span className="font-mono text-xs text-gray-500">{a.id}</span> },
    { key: 'hostname', label: 'Agent', render: (a) => <span className="font-medium text-gray-900">{a.hostname || '—'}</span> },
    { key: 'ip', label: 'IP', render: (a) => <span className="font-mono text-xs">{a.ip || '—'}</span> },
    { key: 'os', label: 'OS', render: (a) => <span className="text-xs">{a.os || '—'}</span> },
    { key: 'version', label: 'Agent ver.', render: (a) => <span className="text-xs">{a.version || '—'}</span> },
    {
      key: 'status',
      label: 'Status',
      render: (a) => <Pill ok={a.status === 'active'}>{a.status || '—'}</Pill>,
    },
    { key: 'last_seen', label: 'Last check-in', render: (a) => <span className="whitespace-nowrap text-gray-500">{fmtWhen(a.last_seen)}</span> },
    {
      key: 'in_register',
      label: 'Register',
      render: (a) => (a.in_register
        ? <span className="text-xs text-gray-500">{a.assigned_name || 'known'}</span>
        : <span className="text-xs font-medium text-amber-700">not in register</span>),
    },
  ];

  return (
    <AgentList
      title="Wazuh Agents"
      blurb="Every endpoint enrolled in Wazuh, read live from the Wazuh manager each time you refresh. A newly enrolled machine appears here as soon as it checks in."
      data={data}
      isLoading={isLoading}
      isFetching={isFetching}
      error={error}
      refetch={refetch}
      stats={[
        { label: 'agents', value: data?.total ?? '—' },
        { label: 'active', value: data?.active ?? '—' },
        { label: 'not in register', value: data?.unknown ?? '—' },
      ]}
      columns={columns}
      searchFields={['hostname', 'ip', 'os', 'assigned_name']}
    />
  );
}

export default WazuhAgents;
